import React from "react";
import cn from "classnames";
import styles from "./gateways-list-header.module.scss";
import { TextButton } from "@src/components/atoms/buttons/text-button/text-button";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { useGatewaysListHeaderHook } from "./use-gateways-list-header-hook";
import { useI18N } from "@src/language/language-context";

const cssClassName = "gateways-list-header";

export const GatewaysListHeader = () => {
  const {
    expandAllClickHandler,
    closeAllClickHandler,
    allCollapsed,
    anySourcesVisible,
  } = useGatewaysListHeaderHook();
  const i18n = useI18N();

  const texts = {
    statusAndGateway: i18n("modules.gatewaysListHeader.statusAndGateway"),
    vendorId: i18n("modules.gatewaysListHeader.vendorId"),
    gatewayUuid: i18n("modules.gatewaysListHeader.gatewayUuid"),
    expandAll: i18n("modules.gatewaysListHeader.expandAll"),
    closeAll: i18n("modules.gatewaysListHeader.closeAll"),
  };

  return (
    <table className={styles[cssClassName]}>
      <thead>
        <tr className={styles[`${cssClassName}__header`]}>
          <td
            className={cn(
              styles[`${cssClassName}__grid-cell`],
              styles[`${cssClassName}__grid-cell-header`],
            )}
          >
            <FlexRowContainer horizontalGap={6}>
              {texts.statusAndGateway}

              {allCollapsed && (
                <TextButton
                  clickHandler={expandAllClickHandler}
                  text={texts.expandAll}
                  variant={"blue"}
                />
              )}

              {anySourcesVisible && (
                <TextButton
                  clickHandler={closeAllClickHandler}
                  text={texts.closeAll}
                  variant={"blue"}
                />
              )}
            </FlexRowContainer>
          </td>

          <td
            className={cn(
              styles[`${cssClassName}__grid-cell`],
              styles[`${cssClassName}__grid-cell-header`],
            )}
          >
            {texts.vendorId}
          </td>
          <td
            className={cn(
              styles[`${cssClassName}__grid-cell`],
              styles[`${cssClassName}__grid-cell-header`],
            )}
          >
            {texts.gatewayUuid}
          </td>
        </tr>
      </thead>
    </table>
  );
};
